<div class="modal-header bg-head py-2 d-flex justify-content-between align-items-center">
    <h6 class="modal-title mb-0">Admin : Question Management : Relocate Questions</h6>
    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="onCross()"
    ></button>
  </div>
  <div class="modal-body m-body pt-0 px-0" >
  <div class="row">
    <div class="row tree-row" *ngFor="let item of MajorTopics">
      <div class="col-12 d-flex align-items-baseline">
        <div class="px-1 tree-btn-1">
          <button type="button" class="tree-btn" *ngIf="item.ChildNodeExistInd === 'Y'" (click)="getSubjectTree(item)">
            <i class="fa fa-angle-right" *ngIf="!item.Data"></i>
            <i class="fa fa-angle-down" *ngIf="item.Data"></i>
          </button>
        </div>

        <app-tree-content [Text]="item.Name" [status]="item.Status_Code" ID="item.ID"></app-tree-content>
        <div class="d-flex align-items-center">
          <!-- ✅ Checkbox -->
          <input
            type="checkbox"
            class="form-check-input-sm me-2"
            [(ngModel)]="item.checked"
            [disabled]="enableDisableCheckBox(item)"
            (change)="onCheckboxChange(item)"
            *ngIf="item.ChildNodeExistInd === 'N'"
          />
        </div>

    </div>

      <div *ngIf="item.Data" class="ms-4">
        <app-question-topics-node
        [treeNodes]="item.Data"
        [selectedNodes]="selectedNodes"
        [anyNodeChecked]="anyNodeChecked"
        (selectedNodesChange)="onSelectedNodesChange($event)">
      </app-question-topics-node>
      
      </div>

    </div>
  </div>
</div>
<div class="modal-footer">
    <button
      type="button"
      class=" bl-btn btn btn-sm"
      (click)="onSave()"
    >
      Save
    </button>
    <button
      type="button"
      class=" btn btn-sm bg-light border "
      (click)="this.onCross()">
      Cancel
    </button>
  </div>